var _path, _path2, _path3;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgNotePencil = function SvgNotePencil(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 32,
    viewBox: "0 0 31 32",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.057 1.724c0.521-0.521 1.365-0.521 1.886 0l5.333 5.333c0.521 0.521 0.521 1.365 0 1.886l-21.333 21.333c-0.25 0.25-0.589 0.391-0.943 0.391h-5.333c-0.736 0-1.333-0.597-1.333-1.333v-5.333c0-0.354 0.14-0.693 0.391-0.943l21.333-21.333zM4 24.552v3.448h3.448l20-20-3.448-3.448-20 20z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.667 29.333c0-0.736 0.597-1.333 1.333-1.333h13.333c0.736 0 1.333 0.597 1.333 1.333s-0.597 1.333-1.333 1.333h-13.333c-0.736 0-1.333-0.597-1.333-1.333z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.667 4.781l6.552 6.552-1.886 1.886-6.552-6.552 1.886-1.886z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNotePencil, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/note-pencil.42755600.svg";
export { ForwardRef as ReactComponent };